import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { authActions, getAuth } from "../../../core/auth";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import P from "../../components/p";
import Button from "../../components/button";
import "./styles.css";

const SignIn = ({
  signInWithGithub,
  signInWithGoogle,
  signInWithFacebook,
  auth
}) => (
  <div className="signin">
    <Main>
      <Box>
        <H1>Sign In</H1>
        <P>
          To get started with Ghast please sign in with one of our supported
          providers.
        </P>
        {auth.error ? <P className="error">{auth.error}</P> : null}
        <div>
          {/* <Button
            onClick={signInWithGithub}
            className="m-right no-m-bottom github-bg-color"
          >
            <i className="fab fa-github" /> GitHub
          </Button> */}
          <Button
            onClick={signInWithGoogle}
            className="m-right no-m-bottom google-bg-color"
          >
            <i className="fab fa-google" /> Google
          </Button>
          {/* <Button
            onClick={signInWithFacebook}
            className="m-right no-m-bottom facebook-bg-color"
          >
            <i className="fab fa-facebook-f" /> Facebook
          </Button> */}
        </div>
      </Box>
    </Main>
  </div>
);

SignIn.propTypes = {
  signInWithGithub: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
  signInWithFacebook: PropTypes.func.isRequired
};

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = createSelector(getAuth, auth => ({ auth }));

export default connect(
  mapStateToProps,
  authActions
)(SignIn);



/** WEBPACK FOOTER **
 ** ./src/views/pages/sign-in/index.js
 **/